module.exports = __webpack_public_path__ + "static/gtm-ga4-config-032b4931300ab0aa71ec68a03f835daa.png";